// User-facing texts for BankID hintCodes (BankID's own and Klargo's binding/return codes),
// shared by the login and signing modals.

const HINT_EN = {
  outstandingTransaction: "Start the BankID app on your device.",
  noClient: "Start the BankID app.",
  started: "BankID app opened — enter your security code.",
  userSign: "Enter your BankID security code.",
  expiredTransaction: "The session expired. Please try again.",
  certificateErr: "Invalid BankID certificate.",
  userCancel: "You cancelled in the BankID app.",
  cancelled: "The order was cancelled.",
  startFailed: "BankID could not start. Make sure the app is installed.",
  // Binding / return (Klargo)
  awaitingReturn: "We could not confirm that BankID was used on this device. If the BankID app opened another browser, continue there — or choose \"Scan QR code\" and use BankID on another device.",
  bindingMismatch: "BankID was started in another browser. Go back to the browser where you started, or start again here.",
  unknownOrder: "This BankID session no longer exists (it expired or was cancelled). Please start again.",
  notFound: "The link from BankID has expired. Please start again.",
  loginRequired: "Sign in with the same account in this browser to finish signing, or go back to the browser where you started.",
  wrongUser: "This signature was started by another account. Sign in with that account to finish it.",
  notAuthorized: "This BankID order does not belong to your account.",
  storageUnavailable: "Your browser blocks the storage BankID needs (for example in private mode). Allow site data or use another browser.",
  incompatibleServer: "BankID could not be started securely right now. Reload the page and try again.",
  browserBindingRequired: "BankID could not be started securely right now. Reload the page and try again.",
  returnOriginNotAllowed: "BankID on this device cannot be started from this page. Choose \"Scan QR code\" instead.",
  returnPathNotAllowed: "BankID on this device cannot be started from this page. Choose \"Scan QR code\" instead.",
};

const HINT_SV = {
  outstandingTransaction: "Starta BankID-appen på din enhet.",
  noClient: "Starta BankID-appen.",
  started: "BankID-appen öppnad — ange din säkerhetskod.",
  userSign: "Ange din BankID-säkerhetskod.",
  expiredTransaction: "Sessionen har gått ut. Försök igen.",
  certificateErr: "Ogiltigt BankID-certifikat.",
  userCancel: "Du avbröt i BankID-appen.",
  cancelled: "Beställningen avbröts.",
  startFailed: "BankID kunde inte starta. Kontrollera att appen är installerad.",
  // Bindning / återgång (Klargo)
  awaitingReturn: "Vi kunde inte bekräfta att BankID användes på den här enheten. Om BankID-appen öppnade en annan webbläsare, fortsätt där — eller välj ”Skanna QR-kod” och använd BankID på en annan enhet.",
  bindingMismatch: "BankID startades i en annan webbläsare. Gå tillbaka till webbläsaren där du började, eller starta om här.",
  unknownOrder: "BankID-sessionen finns inte längre (den har gått ut eller avbrutits). Starta igen.",
  notFound: "Länken från BankID har gått ut. Starta igen.",
  loginRequired: "Logga in med samma konto i den här webbläsaren för att slutföra signeringen, eller gå tillbaka till webbläsaren där du började.",
  wrongUser: "Signeringen startades av ett annat konto. Logga in med det kontot för att slutföra den.",
  notAuthorized: "BankID-beställningen tillhör inte ditt konto.",
  storageUnavailable: "Din webbläsare blockerar lagringen som BankID behöver (t.ex. i privat läge). Tillåt webbplatsdata eller använd en annan webbläsare.",
  incompatibleServer: "BankID kunde inte startas säkert just nu. Ladda om sidan och försök igen.",
  browserBindingRequired: "BankID kunde inte startas säkert just nu. Ladda om sidan och försök igen.",
  returnOriginNotAllowed: "BankID på den här enheten kan inte startas från den här sidan. Välj ”Skanna QR-kod” i stället.",
  returnPathNotAllowed: "BankID på den här enheten kan inte startas från den här sidan. Välj ”Skanna QR-kod” i stället.",
};

export const bankIdHints = (language) => (language?.startsWith("sv") ? HINT_SV : HINT_EN);

// How long a completed same-device order may wait for the return before the user is told how
// to recover. A return in the same browser normally arrives within a second or two.
export const AWAITING_RETURN_GRACE_MS = 8000;
